import { useState } from "react";
import useDebtWarehouseHistoryTab from "../../hooks/useDebtWarehouseHistoryTab";
import { Stack, Typography } from "@mui/material";
import TableComp from "src/components/shared/table/TableComp";
import DebtFilter from "../../components/DebtFilter";
import { DebtWarehouseHistoryDetailDialog } from "../Dialogs";
import { formatCurrency } from "src/helper/convertNum";
import convertCurrency from "src/helper/convertCurrency";

const DebtWarehouseHistoryTab = ({ date }) => {
  const [filter, setFilter] = useState();

  const { bodyList, sortData, pagi, setPagi, total, header, footerTotals, setSelectedRow, selectedRow } = useDebtWarehouseHistoryTab({ date, filter });

  const handleCloseDetail = () => {
    setSelectedRow(null);
  };

  return (
    <>
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        my="14px"
      >
        <DebtFilter
          variant="payment-history"
          setFilter={setFilter}
          filter={filter}
        />
      </Stack>
      <TableComp
        bodyList={bodyList}
        headers={header}
        sortData={sortData}
        setPagi={setPagi}
        pagi={pagi}
        total={total}
        noBackground
        TableFooterComponent={
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            spacing={4}
            sx={{ py: 2, borderTop: "1px solid var(--grey)" }}
          >
            <Typography fontWeight="bold">Tổng:</Typography>
            <Stack
              alignItems="center"
              maxWidth="200px"
              sx={{
                textAlign: "center",
              }}
            >
              <Typography fontWeight="bold">
                {footerTotals?.all >= 0 ? "+" : ""}
                {formatCurrency(footerTotals?.all) ?? 0}
              </Typography>
              {footerTotals?.all && (
                <Typography
                  color="#989898"
                  fontSize="8px"
                  fontStyle="italic"
                >
                  {convertCurrency(footerTotals?.all)} đồng
                </Typography>
              )}
            </Stack>
            <Stack
              alignItems="center"
              maxWidth="200px"
              sx={{
                textAlign: "center",
              }}
            >
              <Typography fontWeight="bold">
                {footerTotals?.paid > 0 ? "-" : "+"}
                {formatCurrency(Math.abs(footerTotals?.paid)) ?? 0}
              </Typography>
              {footerTotals?.paid && (
                <Typography
                  color="#989898"
                  fontSize="8px"
                  fontStyle="italic"
                >
                  {convertCurrency(footerTotals?.paid)} đồng
                </Typography>
              )}
            </Stack>
            <Stack
              alignItems="center"
              maxWidth="200px"
              sx={{
                textAlign: "center",
              }}
            >
              <Typography fontWeight="bold">
                {footerTotals?.unpaid < 0 ? "-" : "+"}
                {formatCurrency(Math.abs(footerTotals?.unpaid)) ?? 0}
              </Typography>
              {footerTotals?.unpaid && (
                <Typography
                  color="#989898"
                  fontSize="8px"
                  fontStyle="italic"
                >
                  {convertCurrency(footerTotals?.unpaid)} đồng
                </Typography>
              )}
            </Stack>
          </Stack>
        }
      />
      <DebtWarehouseHistoryDetailDialog
        open={!!selectedRow}
        onClose={handleCloseDetail}
        selectedRow={selectedRow}
      />
    </>
  );
};

export default DebtWarehouseHistoryTab;
